// extracted by mini-css-extract-plugin
module.exports = {"EnergyFootprintTable":"EnergyFootprint_EnergyFootprintTable__YWJcQ","Arrow":"EnergyFootprint_Arrow__8NaWo"};